import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { NoteService } from '../../shared/services/note.service';
@Component({
  selector: 'app-expertise-add-note',
  templateUrl: './expertise-add-note.component.html',
  styleUrls: ['./expertise-add-note.component.scss'],
  providers: [
  	NoteService,
  ]
})
export class ExpertiseAddNoteComponent implements OnInit {

	@Input() expertiseId: number;
  @Output() noteAdded: EventEmitter<any> = new EventEmitter<any>();
 	users: string[] = [];
  	text: string = '';
  	constructor(
  		private userService: UserService,
  		private noteService: NoteService
  	) { }

  	ngOnInit() {
  		this.userService.getAll('name',2,{},0,20).subscribe(t => this.users = (t.body).map(u => u.publicIdentity));  
  	}


  	addNote() {
  		let note = {
  			object_type: 'Expertise',
  			object_id: this.expertiseId,
  			note: this.text,  			
  		};

  		this.noteService.create(note).subscribe(n => {  			
  			this.text = '';
        this.noteAdded.emit(n);
  		})
  	}

}
